import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import "./SingleProject.css";
import { projectDatas } from "../../projects";
import { FaGithub } from "react-icons/fa";
import { CgWebsite } from "react-icons/cg";
import AOS from "aos";
import "aos/dist/aos.css";

const SingleProject = () => {
  const { id } = useParams();

  const [project, setProject] = useState(null);

  useEffect(() => {
    const myProject = projectDatas.find((p) => p.id === parseInt(id));
    if (myProject) {
      setProject(myProject);
    }

    AOS.init({ duration: 3000 });
    AOS.refresh();
    window.scrollTo(0, 0);
  }, [id]);

  return (
    <div className="single-p-container">
      <div className="mb-1"></div>
      <div className="back-btn">
        <Link to="/projects">
          <button className="backtohome">&#60; Back to Projects List</button>
        </Link>
      </div>
      <div className="single-container">
        <div className="project-box">
          <h1 className="single-heading">
            This is a <span style={{ color: "	#0057E9" }}>{project?.title}</span>{" "}
            application
          </h1>
          <span className="single-i-box">
            {project?.icons.map((icon) => (
              <img src={icon} key={icon} alt={icon} className="single-icon" />
            ))}
          </span>

          <div className="single-links-box">
            <span className="single-link-box">
              <span>
                <FaGithub className="single-small-icon" />
              </span>
              <a href={project?.gitLink} target="_blank" rel="noreferrer">
                View Code in Git
              </a>
            </span>

            {project?.deployedLink ? (
              <span className="single-link-box">
                <span>
                  <CgWebsite className="single-small-icon" />
                </span>
                <a
                  href={project?.deployedLink}
                  target="_blank"
                  rel="noreferrer"
                >
                  View Deployed Project
                </a>
              </span>
            ) : (
              ""
            )}
          </div>
          <h2 className="single-heading2">
            Performed using{" "}
            <span className="framework-title">{project?.framework}</span>
          </h2>
        </div>

        <div className="single-image-box">
          <div className="mb-3"></div>

          <img
            src={project?.image}
            className="single-image"
            alt={project?.title}
          />
        </div>
      </div>
      <div className="mb-2"></div>
      <p className="single-detail">{project?.detail}</p>
    </div>
  );
};

export default SingleProject;
